import { render, staticRenderFns } from "./CreateRationModal.vue?vue&type=template&id=495d78f6&scoped=true&lang=pug"
import script from "./CreateRationModal.vue?vue&type=script&lang=js"
export * from "./CreateRationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495d78f6",
  null
  
)

export default component.exports